import { render, staticRenderFns } from "./CreateBox.vue?vue&type=template&id=757007c9&scoped=true"
import script from "./CreateBox.vue?vue&type=script&lang=js"
export * from "./CreateBox.vue?vue&type=script&lang=js"
import style0 from "./CreateBox.vue?vue&type=style&index=0&id=757007c9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757007c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('757007c9')) {
      api.createRecord('757007c9', component.options)
    } else {
      api.reload('757007c9', component.options)
    }
    module.hot.accept("./CreateBox.vue?vue&type=template&id=757007c9&scoped=true", function () {
      api.rerender('757007c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/CreateBox.vue"
export default component.exports